console.log('[App Init] Entry point loaded, importing bootstrap...');

import('./bootstrap')
    .then(() => {
        console.log('[App Init] Bootstrap loaded successfully');
    })
    .catch((error) => {
        console.error('[App Init] Failed to load bootstrap:', error);
        window.appLoaded = true;
        const root = document.getElementById('root');
        if (root) {
            root.innerHTML = `
                <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;font-family:sans-serif;padding:20px;">
                    <h2 style="color:#e74c3c;margin-bottom:16px;">Application failed to load</h2>
                    <p style="color:#666;margin-bottom:16px;">${error?.message || 'Unknown error'}</p>
                    <button onclick="window.location.reload()" style="padding:8px 16px;background:#0066cc;color:white;border:none;border-radius:4px;cursor:pointer;">Retry</button>
                </div>
            `;
        }
    });
